module.exports = __webpack_public_path__ + "media/images/icons/surveys-42a7d5112d70a793ca294bff0e44e455.svg";